import { Component, signal } from '@angular/core';
import { AngularModule } from '../../../modules/angular.module';
import { ZorroModule } from '../../../modules/zorro.module';
import { NavigationService } from '../../../services/navigation.service';
import { BreadcrumbsComponent } from '../../ui/admin/breadcrumbs/breadcrumbs.component';
import { CognitoService } from '../../../services/cognito.service';
import { AuthService } from '../../../services/auth.service';
import { SetupWizardState } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-admin',
	standalone: true,
	imports: [AngularModule, ZorroModule, BreadcrumbsComponent],
	templateUrl: './admin.component.html',
	styleUrl: './admin.component.scss',
})
export class AdminComponent {
	readonly isAdmin = signal(false);
	readonly isClientAdmin = signal(false);
	readonly isDistrictAdmin = signal(false);
	readonly isSchoolAdmin = signal(false);
	readonly isTeacher = signal(false);
	readonly isDemo = signal(false);

	readonly SetupWizardState = SetupWizardState;

	constructor(
		public nav: NavigationService,
		private cognitoService: CognitoService,
		public authService: AuthService
	) {
		this.cognitoService.isCurrentTokenValid();

		this.authService.isAdmin$().then(isAdmin => {
			this.isAdmin.set(isAdmin);
		});

		this.authService.isClientAdmin$().then(isClientAdmin => {
			this.isClientAdmin.set(isClientAdmin);
		});

		this.authService.isDistrictAdmin$().then(isDistrictAdmin => {
			this.isDistrictAdmin.set(isDistrictAdmin);
		});

		this.authService.isSchoolAdmin$().then(isSchoolAdmin => {
			this.isSchoolAdmin.set(isSchoolAdmin);
		});

		this.authService.isTeacher$().then(isTeacher => {
			this.isTeacher.set(isTeacher);
		});

		this.authService.isDemo$().then(isDemo => {
			this.isDemo.set(isDemo);
		});
	}
}
